import { UiSchema } from '@rjsf/utils';
import { Select } from 'components';
import { inOptions } from 'domain/utils/select.utils';
import { useEffect, useMemo, useState } from 'react';
import { elementsClassName, useSchemaProps } from '../JsonRenderer';

import { useRelEntities } from 'domain/hooks/hal/hal.service';
import { useOptions } from 'domain/utils/forms.utils';
import { OnChangeValue } from 'react-select';

import cn from 'classnames';
import { WidgetProps } from './Widgets';

export const RelationSelect = ({
	rel,
	values,
	uiSchema,
	onChange,
	onlyOne,
}: {
	rel: string;
	values: any[];
	uiSchema: UiSchema;
	onChange(values: any[]): any;
	onlyOne?: boolean;
}) => {
	// Get the entity lists
	const [entities] = useRelEntities(rel);

	const options = useOptions(entities, rel);

	const picked = useMemo(() => {
		const filtered = (values && Object.values(values)) ?? [];
		return filtered.filter((v: any) => !!v).map((v: any) => v.id);
	}, [values]);

	const { readonly } = useSchemaProps(uiSchema);

	return (
		<Select
			isMulti={!onlyOne}
			isDisabled={readonly}
			className={cn(elementsClassName)}
			options={options}
			value={inOptions(options, picked)}
			onChange={(newValue: OnChangeValue<any, any>) => {
				if (onlyOne) {
					onChange(newValue ? [newValue.value] : []);
					return;
				}
				onChange(newValue.map((v: any) => ({ id: v.value, label: v.label })));
			}}
		/>
	);
};
export const RelationSelectComponent = ({
	value,
	uiSchema,
	onChange,
}: WidgetProps<string>) => {
	// Get the rel from the uiSchema
	const rel = uiSchema['ui:rel'];

	// We use the value both as value and identifier
	return (
		<RelationSelect
			rel={rel}
			values={value ? [{ id: value }] : []}
			uiSchema={uiSchema}
			onChange={(v) => {
				const actualValue = v?.[0] ?? '';
				onChange(actualValue);
			}}
			onlyOne
		/>
	);
};
